import { BaseCollection } from './BaseCollection'
import GenericModel from './GenericModel'

class GenericCollection extends BaseCollection {
    model() {
        return GenericModel
    }

    createModel(attributes) {
        return new (this.model())(attributes).setResourceName(
            this.getResourceName()
        )
    }
}

export default GenericCollection
